export default __webpack_public_path__ + "static/media/mountain.f6077878.png";